import produce from 'immer';

const INITIAL_STATE = {
  opened: false,
};

export default function notification(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@auth/SIGN_IN_SUCCESS':
      case '@notification/OPEN': {
        draft.opened = true;
        break;
      }

      // Adicionar case

      case '@notification/CLOSE': {
        draft.opened = false;
        break;
      }

      default:
    }
  });
}
